import { z } from 'zod';
import { REQUIRED_ERROR } from '@/domains/auth/constants/validation';

export const validationSchema = z.object({
  username: z.string().min(1, REQUIRED_ERROR),
  password: z.string().min(1, REQUIRED_ERROR),
});
